// @unocss-include
import { useEffect } from 'react';
export function useVirtualKeyboardBehavior(behavior) {
    useEffect(() => {
        if ('virtualKeyboard' in navigator) {
            // @ts-ignore
            navigator.virtualKeyboard.overlaysContent = behavior === 'overlay';
        }
    }, [behavior]);
}
//# sourceMappingURL=useVirtualKeyboardBehavior.js.map